import { REGEX_CURRENCY } from '@/constants/regex'

/**
 * @function currencyFormat
 * This function helps you format the number as currency
 * @param number
 * @returns string of number formatted as currency
 */
export const currencyFormat = (number: number, currencySymbol?: string) => {
  const negative = '-'
  return String(number).search('-') === 0
    ? negative + String(number).split('-')[1].replace(REGEX_CURRENCY, '$1,')
    : String(number).replace(REGEX_CURRENCY, '$1,')
}

/**
 * @function getFormatNumber
 * This function returns the numbers with the Swiss format,
 * separated by apostrophe (default) with minimum and maximum two decimals
 */
export const getFormatNumber = (
  num: number,
  currency?: string,
  locale?: string,
  thousandSeparator?: string,
) => {
  const formatter = new Intl.NumberFormat(locale || 'en-US', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })

  let newNumber = formatter.format(num)

  if (thousandSeparator) newNumber = newNumber.replace(',', thousandSeparator)

  return currency ? `${currency} ${newNumber}` : newNumber
}

export default currencyFormat
